export const getDisplayChipBorder = ({ isEditing, value, error, readOnly }) => {
  if (readOnly) {
    return "transparent"
  }
  if (error) {
    return "var(--clr-danger)"
  }
  if (isEditing || value) {
    return "var(--clr-info)"
  }
  return "var(--secondary-color-highlight)"
}

/**
 * Search if client has a projectCode. The client format must be: [
 *  code,
 *  items: [] // projects
 *  name,
 *  type,
 *  ...etc
 * ]
 * @param {Array} client
 * @param {String} projectCode
 * @returns
 */
export const findClientWithProject = (clients = [], projectCode) => {
  return clients.find((client) => {
    return client.items.some((project) => project.code === projectCode)
  })
}
